import React from 'react';
import "../../fotter.css"
import fb from "../../assets/images/social-media/fb.png"
import tweet from "../../assets/images/social-media/tweet.png"
import insta from "../../assets/images/social-media/insta.png"
import printest from "../../assets/images/social-media/pinterest.png"
import linkedin from "../../assets/images/social-media/linkedin.png"
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="footer">

            <div className="link">
                <Link to="/about" style={{ textDecoration: 'none' }}><p>About Us</p></Link>
                <Link to="/contact" style={{ textDecoration: 'none' }}><p>Contact</p></Link>
                <Link to="/terms" style={{ textDecoration: 'none' }}><p>Terms Of Service</p></Link>
                <Link to="/privacy" style={{ textDecoration: 'none' }}><p>Privacy Policy</p></Link>
                <Link to="/faq" style={{ textDecoration: 'none' }}><p>FAQ’s</p></Link>
                <Link to="/attributes" style={{ textDecoration: 'none' }}><p>Attributes</p></Link>

            </div>

            <div className="social">
                <a href="https://www.facebook.com/priyanka.chatterjee9075/" target='_blank' ><img src={fb} alt="fb" /></a>
                <a href="https://www.instagram.com/pri_chatterjee/" target='_blank' ><img src={insta} alt="insta" /></a>
                <a href="https://www.linkedin.com/in/priyanka-9075/" target='_blank' ><img src={linkedin} alt="linkedin" /></a>
                <a href="#"><img src={tweet} alt="tweet" /></a>
                {/* <a href="https://in.pinterest.com/kredeycompany/_saved/"><img src={printest} alt="printest" /></a> */}
            </div>
            <p className="copyright">Copyright &#169;2021 Friend a Book | Made with 💖 by <a target='_blank' href="https://github.com/Priyanka-Chatterjee-2000">Pri</a></p>

        </div>
    )
}
export default Footer;